<!-- 
Top level application component.
Sets the layout to use and handles transition effects when moving between routes.
Everything else is delegated to the router.
-->
<template>
  <div id="app">
    <v-app id="v-app">
      <component :is="layout">
        <transition :name="transition" mode="out-in">
          <router-view/>
        </transition>
      </component>
      <client-out-of-date-warning />
      <global-error-warning />
    </v-app>
  </div>
</template>

<script>
import ClientOutOfDateWarning from "@/components/system/ClientOutOfDateWarning.vue";
import GlobalErrorWarning from "@/components/system/GlobalErrorWarning.vue";
import * as systemAction from "@/store/system/action-types";

export default {
  components: { ClientOutOfDateWarning, GlobalErrorWarning },
  computed: {
    transition() {
      const specifiedTransition = this.$route.meta.transitionName;
      return specifiedTransition ? specifiedTransition : "fade";
    },
    layout() {
      const specifiedLayout = this.$route.meta.layout;
      if (specifiedLayout) {
        return specifiedLayout;
      }
      return this.$store.getters.isSignedIn ? "layout-for-staff" : "layout-for-anonymous";
    }
  },
  created() {
    this.$store.dispatch(systemAction.SYSTEM_DETAILS_REFRESH);
  }
};
</script>
